/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrdineDettaglioCreateDTO
 */
export interface OrdineDettaglioCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof OrdineDettaglioCreateDTO
     */
    codiceProdotto?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrdineDettaglioCreateDTO
     */
    quantita?: number;
}

/**
 * Check if a given object implements the OrdineDettaglioCreateDTO interface.
 */
export function instanceOfOrdineDettaglioCreateDTO(value: object): value is OrdineDettaglioCreateDTO {
    return true;
}

export function OrdineDettaglioCreateDTOFromJSON(json: any): OrdineDettaglioCreateDTO {
    return OrdineDettaglioCreateDTOFromJSONTyped(json, false);
}

export function OrdineDettaglioCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdineDettaglioCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'codiceProdotto': json['codiceProdotto'] == null ? undefined : json['codiceProdotto'],
        'quantita': json['quantita'] == null ? undefined : json['quantita'],
    };
}

  export function OrdineDettaglioCreateDTOToJSON(json: any): OrdineDettaglioCreateDTO {
      return OrdineDettaglioCreateDTOToJSONTyped(json, false);
  }

  export function OrdineDettaglioCreateDTOToJSONTyped(value?: OrdineDettaglioCreateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'codiceProdotto': value['codiceProdotto'],
        'quantita': value['quantita'],
    };
}

